import React from 'react';
import { Toaster } from '@/components/ui/sonner';
import { Header } from '@/components/hemera/Header';
import { Hero } from '@/components/hemera/Hero';
import { Services } from '@/components/hemera/Services';
import { TechGrid } from '@/components/hemera/TechGrid';
import { EngagementModels } from '@/components/hemera/EngagementModels';
import { Pricing } from '@/components/hemera/Pricing';
import { Projects } from '@/components/hemera/Projects';
import { About } from '@/components/hemera/About';
import { Contact } from '@/components/hemera/Contact';
import { Footer } from '@/components/hemera/Footer';
export function HomePage() {
  return (
    <div className="min-h-screen bg-background text-foreground selection:bg-primary/20">
      <Header />
      <main>
        <Hero />
        <section id="services">
          <Services />
        </section>
        <section id="tech-stack" className="bg-slate-50/50 dark:bg-slate-900/20">
          <TechGrid />
        </section>
        <section id="scenarios">
          <EngagementModels />
        </section>
        <section id="engagement" className="bg-slate-50/50 dark:bg-slate-900/20">
          <Pricing />
        </section>
        <section id="projects">
          <Projects />
        </section>
        <section id="about" className="bg-slate-50/50 dark:bg-slate-900/20">
          <About />
        </section>
        <section id="contact" className="bg-slate-50/50 dark:bg-slate-900/20">
          <Contact />
        </section>
      </main>
      <Footer />
      <Toaster richColors closeButton />
    </div>
  );
}